import { render, staticRenderFns } from "./ResourceTeamsDialog.vue?vue&type=template&id=02e12989&scoped=true&"
import script from "./ResourceTeamsDialog.vue?vue&type=script&lang=js&"
export * from "./ResourceTeamsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ResourceTeamsDialog.vue?vue&type=style&index=0&id=02e12989&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e12989",
  null
  
)

export default component.exports